import React from 'react';

import { MobileScreen } from '../../ResponsiveScreens';

export default function AddBtnMobile({ editable, cardData }) {
  function handleClick() {
    if (editable.isLoading) return null;

    editable.edit({ cardData, message: editable.message });
  }
  return (
    <MobileScreen>
      {editable && (
        <div className="mobile-btn">
          <a className="btn-add-mobile" onClick={handleClick}>
            {editable.isLoading
              ? editable.isAdded
                ? 'Removing...'
                : 'Adding...'
              : editable.isAdded
              ? 'Remove'
              : 'Add'}
          </a>
        </div>
      )}
    </MobileScreen>
  );
}



// WEBPACK FOOTER //
// ./src/components/Cards/Common/AddBtnMobile.jsx